import apiFetch from '../apiFetch'
export default function (organizedUnitId, dossierSubtype, token, includeDeleted = false) {
  return apiFetch({ endPoint: `SaleType/UO/${organizedUnitId}/SubType/${dossierSubtype}?includeDeleted=${includeDeleted}`, method: 'GET', body: null, token: token })
}
